<style scoped lang="less">
@import '../../assets/less/base.less';
.search-select-box{
    font-size: 13px;
    color: #888;
    float: left;
    .el-select{
        cursor: pointer;
        width: 200px;
    }
    .el-input--suffix{
        .focus-border{
            border-color: #409EFF !important;
        }
    }
    .el-input__inner:focus{
        border-color: #dcdfe6;
    }
    .el-input__suffix{
        .el-input__suffix-inner{
            .el-input-rotate{
                transform: rotateZ(360deg);
            }
        }
    }
    .drop-select-box{
        position: absolute;
        top: 41px;
        color: #000;
        border: 1px solid @default-gray;
        border-radius: 4px;
        background-color: @default-backGray;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        width: 100%;
        transform-origin: center top 0px;

        .search-select{
            width: 90%;
            margin: 0 auto;
            padding: 15px 0px;
            input{
                border-radius: 30px;
            }
        }
        .select-box{
            color: #888;
            padding: 6px 0;
            max-height: 240px;
            overflow: auto;
            li{
                font-size: 14px;
                padding: 0 20px;
                position: relative;
                white-space: nowrap;
                height: 34px;
                line-height: 34px;
                color: @default-fontColor;
                position: relative;
                &:hover{
                    color: @active-color;
                }
            }
            .slected-li{
                color: @active-color;
                >span{
                    background: url('../../../static/images/select-active.png') no-repeat;
                    display: inline-block;
                    width: 13px;
                    height:10px;
                    margin-top: 12px;
                    position: absolute;
                    right: 20px;
                }
            }
        }
    }

}
</style>
<template>
    <div class="search-select-box" v-clickoutside="outClick">
        <div class="el-select" @click="toggleSelect">
            <div class="el-input el-input--suffix">
                <input v-model="chooseVal.name" autocomplete="off" :placeholder="placetext" ref="selectInput" readonly="readonly"
                    type="text" rows="2" class="el-input__inner" :class="{'focus-border': isFocus}">
                <span class="el-input__suffix">
                    <span class="el-input__suffix-inner">
                        <i class="el-select__caret el-input__icon el-icon-arrow-up" :class="{'el-input-rotate':isFocus}"></i>
                    </span>
                </span>
            </div>
            <transition name="el-zoom-in-top">
                <div v-show="isFocus" class="drop-select-box" @click.stop="stopPop">
                    <div class="search-select">
                        <el-input
                            size="small"
                            placeholder="搜索"
                            suffix-icon="el-icon-search"
                            v-model="searchVal">
                        </el-input>
                    </div>
                    <ul class="select-box">
                        <li v-for="item in filterArr" :class="{'slected-li': arrIndexOf(chooseVal, item) >= 0}"
                            :key="item.id" @click="chooseKeyWords(item)">{{item.name}}
                            <span></span>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
//introduce: 多选下拉框
//1、根据props传入相应列表参数
//2、在外层添加事件监听 choose

//引入element-ui工具方法
import clickoutside from "element-ui/src/utils/clickoutside"

import eventBus from '../../eventBus/eventBus.js'

export default {
  components: {},
  props: {
      placetext: {
          type: String,
          default: '筛选'
      },
      mark: null,
      selectTotalArr: {//下拉数据
          default: function(){
              return [{
                  name: '',
                  id: ''
              }]
            }
      }
  },
  data() {
    return {
        chooseVal: [],//选中的数组
        isFocus: false,//是否选中
        searchVal: "",//搜索内容
        filterArr: [],//展示数组
    };
  },
  watch:{
    //
    searchVal:function(){
        this.searchText()
    },
    //监听外层的列表数据 变更的话，清空当前列表与选中列表
    selectTotalArr: function(newVal, oldVal){
        this.filterArr = newVal.slice(0);
        //清空选中列表，并同时向外层广播，删除外层选中项 ----事件大爆炸 - -
        _.each(this.chooseVal, (val, index, arr)=>{
            this.popEmit(val)
        })
        this.chooseVal = [];
    }
  },
  directives: {
      clickoutside,
  },
  methods: {
      //输入框状态切换
      toggleSelect(e){
        let element = this.$refs.selectInput;
        // true为关闭 false为打开
        let judge = element.className.indexOf("focus-border") !== -1;
        if(judge){
            this.isFocus = false;
        }else{
            this.isFocus = true;
        }
      },
      //防止下拉搜索框冒泡
      stopPop(){},
      //搜索的值改变的回调
      searchText(){
        this.filterArr.length = [];
        let nameArr = this.selectTotalArr.filter((val, index, arr) => {
            return ( (val.name.indexOf(this.searchVal) !=-1) || (val.id == this.searchVal) )
        })
        this.filterArr = nameArr.slice(0);
      },
      //选择菜单某一项时
      chooseKeyWords(obj){
          this.isFocus = false;
          let judge = this.arrIndexOf(this.chooseVal, obj);
          if(judge === -1){
            this.chooseVal.push(obj);
          }else if(judge >= 0){
            this.chooseVal.splice(judge, 1);
          }
          this.popEmit(obj)
      },
      //向外层广播事件
      popEmit(obj){
          //先循环添加父级id，外层删除
          let temp = [];
          _.each(this.chooseVal, (val, index, arr)=>{
              val.pid = this.mark;
              temp.push(val)
          })
          this.$emit("choose", obj)
      },
      outClick(){
        let element = this.$refs.selectInput;
        // true为关闭 false为打开
        let judge = element.className.indexOf("focus-border") !== -1;
        if(judge){
            this.isFocus = false;
        }
      },
      //查看选中项数组中是否包含当前选中对象
      arrIndexOf(arr,item){
          let judge = arr.indexOf(item);
          return judge
      }
  },
  created() {
    //第一次将全部数组添加到展示数组
    this.filterArr = this.selectTotalArr.slice(0);
    //监听外层传递的删除事件 删除某个单独项
    eventBus.$on(this.mark, (obj)=>{
        //遍历选中数组， 根据id删除选中的值
        _.each(this.chooseVal, (val, index, arr)=>{
            if(obj.id == val.id){
                this.chooseVal.splice(index, 1)
            }
        })
    })
    //监听外层传递的删除事件 删除全部选中项
    eventBus.$on(this.mark+'all', (obj)=>{
        this.chooseVal = [];
    })

  },
  mounted() {
  }
};
</script>





// WEBPACK FOOTER //
// src/containers/SearchSelect/SearchSelect.vue